import { SearchColumnDef } from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

export const getDocumentsColumns = (): SearchColumnDef[] => [
  {
    field: 'hoa_don_ban_hang_data',
    headerName: 'Số hóa đơn',
    width: 160,
    renderCell: params => params.row.hoa_don_ban_hang_data?.so_ct
  },
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.ma_vt
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => params.row.ma_vt_data?.ten_vt
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: params => params.row.dvt_data?.dvt
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    renderCell: params => formatMoney(params.row.so_luong)
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => params.row.ma_kho_data?.ma_kho
  },
  {
    field: 'sl_ton',
    headerName: 'Tồn',
    width: 140,
    renderCell: params => formatMoney(params.row.sl_ton)
  },
  {
    field: 'gia_nt2',
    headerName: 'Giá bán VND',
    type: 'number',
    width: 170,
    renderCell: params => formatMoney(params.row.gia_nt2)
  },
  {
    field: 'tien_nt2',
    headerName: 'Doanh số VND',
    width: 170,
    type: 'number',
    renderCell: params => formatMoney(params.row.tien_nt2)
  },
  {
    field: 'ma_thue',
    headerName: 'Mã thuế',
    width: 120,
    renderCell: params => params.row.ma_thue_data?.ma_thue
  },
  {
    field: 'tk_thue_co',
    headerName: 'Tk thuế có',
    width: 120,
    renderCell: params => params.row.tk_thue_co_data?.code
  },
  {
    field: 'thue_suat',
    headerName: 'Thuế suất (%)',
    type: 'number',
    width: 120,
    renderCell: params => params.row.ma_thue_data?.thue_suat
  }
];
